import {CALL_API} from 'redux/middleware/api'
import {
  BILLING_PLANS,
  BILLING_SET_PLAN,
  BILLING_CANCEL_PLAN,
  BILLING_PREVIEW_PLAN,
  BILLING_FETCH_INVOICES,
  BILLING_UPDATE_PAYMENT
} from './'
import {
  fetchMerchant
} from 'redux/modules/merchants/actions'
import {getCurrentMerchant} from '../currentUser/selectors'

export function fetchBillingPlans() {
  return dispatch => dispatch({
    [CALL_API]: {
      method: 'GET',
      endpoint: 'billing/plans',
      errorsHandled: true,
      types: BILLING_PLANS
    }
  })
}

export function createPaymentMethod({type, cardNumber, cardCvv, cardExpire}) {
  return (dispatch, getState) => {
    const {id} = getCurrentMerchant(getState())
    return dispatch({
      [CALL_API]: {
        method: 'POST',
        endpoint: `merchants/${id}/billing/payment-method`,
        errorsHandled: true,
        types: BILLING_UPDATE_PAYMENT,
        body: {type, cardNumber, cardCvv, cardExpire}
      }
    })
  }
}

export function updateSubscriptionCall(planId, merchantId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `merchants/${merchantId}/billing/subscription`,
      errorsHandled: true,
      types: BILLING_SET_PLAN,
      body: {
        planId
      }
    }
  }
}

export function updateSubscription(planId) {
  return (dispatch, getState) => {
    const {id} = getCurrentMerchant(getState())
    return dispatch(updateSubscriptionCall(planId, id))
      .success(() => dispatch(fetchMerchant()))
  }
}

export function cancelSubscription() {
  return (dispatch, getState) => {
    const {id} = getCurrentMerchant(getState())
    return dispatch({
      [CALL_API]: {
        method: 'DELETE',
        endpoint: `merchants/${id}/billing/subscription`,
        errorsHandled: true,
        types: BILLING_CANCEL_PLAN
      }
    }).success(() => dispatch(fetchMerchant()))
  }
}

export function fetchInvoices() {
  return (dispatch, getState) => {
    const {id} = getCurrentMerchant(getState())
    return dispatch({
      [CALL_API]: {
        method: 'GET',
        endpoint: `merchants/${id}/billing/invoices`,
        errorsHandled: true,
        types: BILLING_FETCH_INVOICES
      }
    })
  }
}

export function fetchUpcomingInvoice(planId) {
  return (dispatch, getState) => {
    const {id} = getCurrentMerchant(getState())
    return dispatch({
      [CALL_API]: {
        method: 'GET',
        endpoint: `merchants/${id}/billing/invoices/upcoming`,
        errorsHandled: true,
        types: BILLING_PREVIEW_PLAN,
        queryParams: {planId}
      }
    })
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/billing/actions.js